export interface IViewFinancialSnapshotRequest {
  clientID: string;
  partnerID: string;
  preferredCurrency?: string; // OMIT now as we have default currency: GBP
}

export interface IAssetDetails {
  assetAmount: string;
  assetCurrency: string;
  assetType: string;
}
export interface IViewFinancialSnapshotResponse {
  clientID: string;
  partnerID: string;
  currency: string;
  all: {
    assetAmount: string;
    liabilityAmount: string;
    netAmount: string;
  };
  client: {
    name: string;
    assetAmount: string;
    liabilityAmount: string;
    netAmount: string;
    assetDetails: IAssetDetails[];
  };
  partner: {
    name: string;
    assetAmount: string;
    liabilityAmount: string;
    netAmount: string;
    assetDetails: IAssetDetails[];
  };
  joint: {
    assetAmount: string;
    liabilityAmount: string;
    netAmount: string;
    assetDetails: IAssetDetails[];
  };
}

export interface IViewFFTimelineEventRequest {
  eventID: string;
}

export interface FFSectionInfo {
  sectionName: string;
  subSectionName: string;
  belongType: string;
  fields: FFFieldInfo[];
}

export interface FFFieldInfo {
  displayedName: string;
  oldData: string;
  newData: string;
  isUpdated: boolean;
}

export interface ManualEditDetails {
  editedBy: string;
  editTime: Date;
  ffChanges: FFSectionInfo[];
}

export interface DocumentDetails {
  documentName: string;
  uploadedBy: string;
  recipient: string;
  uploadedAt: Date;
  attachment: string;
  documentFileName: string;
  documentFileID: string;
}

export interface EmailBodyAttachment {
  ffEmailContentID: string;
  emailDataSource: string;
  fileName: string;
  isProcessed: boolean;
  unexpectedAttachment: boolean;
  documentType: string;
}
export interface EmailDetails {
  subject: string;
  senderUser: string;
  recipientUser: string;
  sentTime: Date;
  emailStatus: string;
  emailBody: EmailBodyAttachment;
  emailAttachments: EmailBodyAttachment[];
}
export interface IViewFFTimelineEventResponse {
  manualEdit?: ManualEditDetails;
  document?: DocumentDetails[];
  email?: EmailDetails;
}

export interface IStakeHolder {
  name: string;
  titleOrRole: string;
  ownershipPercentage: string;
  valuationOfShares: string;
  entityType: string;
}

export interface IBusinessOwnerDetails {
  id: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  clientID: string;
  businessType: string;
  businessName: string;
  registrationNumber: string;
  vatRegistrationNumber: string;
  notes: string;
  natureOfBusiness: string;
  incorporationDate: string;
  legalEntity: {
    identifier: string;
    expiresOn: string;
  };
  businessStatus: string;
  headOfficeLocation: string;
  telephone: string;
  email: string;
  website: string;
  Client: {
    id: string;
    createdAt: string;
    updatedAt: string;
    clientType: string;
    isBusinessClient: boolean;
    clientReferenceNumber: string;
    clientStatus: string;
    planningStatus: string;
    crownEmployeeSpouse: boolean;
    creationDate: string;
    probateDate: string;
    logoDocumentID: string;
    isFactFindDataCaptured: boolean;
  };
}
export interface IGetBusinessOwnershipDetailsResponse {
  clientID: string;
  businessClientDetails: IBusinessOwnerDetails;
  stakeHoldersDetails: IStakeHolder[];
}

export interface IInviteExistingClientRequest {
  title: string;
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  externalReferenceID: string;
}

export enum FactFindType {
  'FACT_FIND' = 'FACT_FIND',
  'AI' = 'AI',
  'PARA_PLANNER' = 'PARA_PLANNER',
}
